import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import Backdrop from '@material-ui/core/Backdrop';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        flexDirection: 'column',
        backgroundColor: 'rgba(0, 0, 0, 0.7)',
    },
    spinnerOffset: {
        marginBottom:'20px'
    },
}));

const BackdropLoading = ({
    open = false,
    onClose = () => {},
    loadingText = "Please wait, our system is processing your data.",
}) => {
    const classes = useStyles();

    return (
        <Backdrop className={classes.backdrop} open={open} onClick={onClose}>
            <CircularProgress color="inherit" className={classes.spinnerOffset} />
            <p style={{marginTop:'80px'}}>{loadingText}</p>
        </Backdrop>
    );
};

export default BackdropLoading;

